<template>
    <div class="navbar-item has-dropdown" ref="wrapper">
        <div class="navbar-item px-0" @click="showOptions = !showOptions">
            <span class="welcome-user">
                <span class="user-picture">
                    <img
                        :src="user.user_image"
                        @error="replaceByDefault"
                        alt=""
                    />
                </span>
                <span class="user-name">
                    {{ $t("Welcome") }}
                    <span style="text-transform: capitalize">{{
                        user.first_name
                    }}</span>
                </span>
            </span>
        </div>
        <div
            :class="['navbar-dropdown', { 'options show': showOptions }]"
            ref="dropdown"
            @click="showOptions = false"
        >
            <!-- <template
                v-if="
                    $store.state.user.token &&
                    $store.state.user.mobile_verified &&
                    $store.state.user.email_verified &&
                    $store.state.userData.is_updated
                "
            >
            <div class="navbar-item">
                    <router-link to="/archived-shipments">
                        <span>{{ $t("Shipment archive") }}</span>
                    </router-link>
                </div> 

                <hr class="navbar-divider" />
                <div class="navbar-item">
                    <router-link to="#">
                        <span>{{ $t("Settings") }}</span>
                    </router-link>
                </div>
                <div class="navbar-item">
                    <router-link to="/my-profile">
                        <span>{{ $t("Profile") }}</span>
                    </router-link>
                </div>
                <div class="navbar-item sm-only">
                    <p @click="changeLang">
                        <span>
                            {{ $i18n.locale == "en" ? "عربي" : "English" }}
                        </span>
                    </p>
                </div>
                <hr class="navbar-divider" />
            </template> -->
            <div class="navbar-item" @click="signOut">
                <a href="#">
                    <span>{{ $t("Sign-out") }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import img from "@/assets/images/user-avatar.svg";
export default {
    data() {
        return {
            showOptions: false,
        };
    },
    methods: {
        replaceByDefault(e) {
            e.target.src = img;
        },
        signOut() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/sign-in/email");
            });
        },

        changeLang() {
            if (this.$i18n.locale == "en") {
                localStorage.setItem("lang", "ar");
            } else {
                localStorage.setItem("lang", "en");
            }
            location.reload();
        },
    },
    computed: {
        user() {
            return this.$store.state.userData;
        },
    },
};
</script>

<style lang="scss" scoped>
.sm-only {
    display: none;

    @media only screen and (max-width: 1000px) {
        display: block !important;
    }
}

::v-deep {
    .px-0 {
        padding: 0 !important;
        padding-bottom: 10px !important;
    }
}

.has-dropdown {
    cursor: pointer;
    margin-top: 15px;

    @media only screen and (max-width: 1000px) {
        display: none !important;
    }

    .welcome-user {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        padding: 0 15px 0 10px;
        border-radius: 15px;
        height: calc(1em + 21px);
        position: relative;

        .user-picture {
            position: absolute;
            top: 4px;

            img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
            }
        }

        .user-name {
            display: inline-block;
            margin-left: 40px;
            font-size: 0.9em;

            & span {
                font-weight: bold;
                // @media only screen and (max-width: 1000px) {
                //     display: none !important;
                // }
            }
        }
    }
}

.show {
    display: block !important;
    position: absolute !important;
    min-width: 175px !important;
}

.navbar-dropdown {
    transition: 0.4s ease-in-out;
    border-top: none;
    opacity: 0;

    &.options {
        opacity: 1 !important;
        padding: 0;
    }

    .navbar-item {
        transition: 0.4s linear;
        padding: 7px 30px;

        &:hover {
            background-color: #f2f2f2;
        }

        a {
            display: inline-block;
            width: 100%;
            transition: 0.4s linear;

            color: #000;

            &:hover {
                color: #262626;
            }
        }
    }
}
</style>
